import {
	IconArrowsLeftRightTrailOutline18,
	IconSliders3Outline18,
} from "nucleo-ui-outline-18"

import type { IconType } from "@productlane/ui"
import {
	CHECK_SPELLING_PROMPT,
	DRAFT_RESPONSE_PROMPT,
	SUMMARIZE_PROMPT,
} from "@productlane/lib/src/writing-quick-actions"
import { CheckSpellingIcon } from "@productlane/ui/src/icons/project/check-spelling-icon"
import { DraftResponseIcon } from "@productlane/ui/src/icons/project/draft-response-icon"
import { SummarizeIcon } from "@productlane/ui/src/icons/project/summarize-icon"

import { ESCALATION_REVIEW_SEED } from "@/lib/agent-assistant-seeds"

export interface ThreadQuickAction {
	label: string
	Icon: IconType
	// Sent in place of the label when the label alone is too terse a prompt.
	message?: string
}

const DEFAULT_ACTIONS: readonly ThreadQuickAction[] = [
	{ label: SUMMARIZE_PROMPT, Icon: SummarizeIcon },
	{ label: DRAFT_RESPONSE_PROMPT, Icon: DraftResponseIcon },
	{ label: CHECK_SPELLING_PROMPT, Icon: CheckSpellingIcon },
]

// A thread opened from the Agent page's Chats: a person had to step in.
export type ThreadView = "agent-chat"

const AGENT_CHAT_ACTIONS: readonly ThreadQuickAction[] = [
	{
		label: "Why did the agent need help?",
		Icon: IconArrowsLeftRightTrailOutline18,
		message:
			"Why couldn't the agent finish this conversation on its own? Point to the message where it got stuck.",
	},
	{
		label: "Fix the setup for next time",
		Icon: IconSliders3Outline18,
		message: ESCALATION_REVIEW_SEED,
	},
	{ label: DRAFT_RESPONSE_PROMPT, Icon: DraftResponseIcon },
]

export function threadQuickActions(
	view: ThreadView | null,
): readonly ThreadQuickAction[] {
	return view === "agent-chat" ? AGENT_CHAT_ACTIONS : DEFAULT_ACTIONS
}
